import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalLikesConfig } from '@/lib/analytics/kpis/youtube/totalLikes';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerLikesConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalLikesConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
